const types = {
    FILTER_AGENDAMENTOS : '@agendamento/FILTER',
    UPDATE_AGENDAMENTO: '@agendamento/UPDATE'
}

export default types